export const theme = {
  borderRadius: "12px",
  colors: {
    dark: "#191919",
    gray: "#595959",
    grayLighter: "#F2F2F2",
    accent: "#00E676",
  },
  fontColors: {
    primary: "#191919",
    secondary: "#595959",
    accent: "#00E676",
  },
  fontSizes: {
    xs: "0.75rem",
    sm: "0.85rem",
    md: "1rem",
    lg: "1.3rem",
    xl: "2rem",
  },
  breakPoints: {
    xs: "425px",
    sm: "768px",
    md: "1024px",
    lg: "2560px",
  },
  spacers: {
    lg: "1.8rem",
  },
};
